import { Box, Typography } from '@mui/material';
import icons from './icons';
import { useState } from 'react';
import palette from './pallete';
import CategoryIcon from './CategoryIcon';

export interface CategoryIconSelectorProps {
  colorValue?: string;
  setColorValue: (color: string) => void;
  iconValue?: string;
  setIconValue: (icon: string) => void;
}

const IconItem = ({
  icon,
  onClick
}: {
  icon: string;
  onClick?: () => void;
}) => {
  const Icon = icons[icon] ?? icons['home'];
  return (
    <Box
      sx={{
        display: 'inline-block',
        p: 1.5,
        height: 'auto',
        cursor: 'pointer',
        borderRadius: 1,
        color: '#555',
        '&:hover': { backgroundColor: '#efefef', color: '#333' }
      }}
      onClick={onClick}
    >
      <Icon fontSize="large" />
    </Box>
  );
};

const ColorPalette = ({ setColor }: { setColor: (color: string) => void }) => {
  return (
    <Box
      sx={{
        width: '227px',
        borderRadius: 1,
        overflow: 'hidden',
        border: '1px solid #ddd'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap'
        }}
      >
        {Object.keys(palette).map(color => (
          <Box
            key={color}
            sx={{
              backgroundColor: palette[color].color,
              color: palette[color].fontColor,
              width: 25,
              height: 25,
              display: 'inline-block',
              cursor: 'pointer'
            }}
            onClick={() => setColor(color)}
          />
        ))}
      </Box>
    </Box>
  );
};

const CategoryIconSelector = ({
  iconValue,
  setIconValue,
  colorValue,
  setColorValue
}: CategoryIconSelectorProps) => {
  const [selectedIcon, setSelectedIcon] = useState(iconValue ?? 'wallet');
  const [selectedColor, setSelectedColor] = useState(colorValue ?? 'white');

  const handleSelectIcon = (icon: string) => {
    setSelectedIcon(icon);
    setIconValue(icon);
  };

  const handleSelectColor = (color: string) => {
    setSelectedColor(color);
    setColorValue(color);
  };

  return (
    <Box>
      <Box>
        <Typography>Select an icon:</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 2 }}>
          <CategoryIcon icon={selectedIcon} color={selectedColor} />
          <ColorPalette setColor={handleSelectColor} />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          height: '200px',
          overflowY: 'auto',
          borderRadius: 1,
          border: '1px solid #ddd'
        }}
      >
        {Object.keys(icons).map(icon => (
          <IconItem
            key={icon}
            icon={icon}
            onClick={() => handleSelectIcon(icon)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CategoryIconSelector;
